import {
	updateEmailId,
	updateFirstName,
	updateIsAuthenticated,
	updateLastName,
	updatePhoneNumber,
} from "../store/userDetailsSlice";
import { useDispatch, useSelector } from "react-redux";

import { LOCAL_USER_BASE_URL } from "../constants/constants";
import axiosRequestInterceptor from "../interceptor/axiosAPIRequestInterceptor";
import { logger } from "../utils/logger";

export const getUserDetails = async (email) => {
	try {
		const response = await axiosRequestInterceptor.post(`/users/getUserDetails`, {
			email: email,
		});
		logger.log("response", response);
		return { success: true, data: response.data };
	} catch (error) {
		logger.log("error", error);
		return { success: false, error: error.response.data.error };
	}
};

export const updateUserDetails = async (email, updates) => {
	try {
		const response = await axiosRequestInterceptor.post(`/users/updateUserData`, {
			email: email,
			...updates,
		});

		logger.log("response", response);
		return { success: true, data: response.data.userDetails };
	} catch (error) {
		logger.log("error", error);
		return { success: false, error: error.response.data.error };
	}
};

export const updatePlan = async (emailId, targetPlan, payableAmount) => {
	try {
		const response = await axiosRequestInterceptor.post(`users/updatePlan`, {
			emailId: emailId,
			targetPlan: targetPlan,
			payableAmount: payableAmount,
		});

		return { success: true, data: response.data };
	} catch (error) {
		logger.log("error", error);
		return { success: false, error: error.response.data.error };
	} 
};

export const startFreeTrial = async (emailId) => {
	try {
		const response = await axiosRequestInterceptor.post(`users/startFreeTrial`, {
			emailId: emailId,
		});

		return { success: true, data: response.data };
	} catch (error) {
		logger.log("error", error);
		return { success: false, error: error.response.data.error };
	} 
};

export const getCredits = async(emailId) => {
    try {
		const response = await axiosRequestInterceptor.post(`users/getCredits`, {
			emailId: emailId
		});

		let data = response.data;
		return data.credits;
    } catch (error) {
      console.log(error);
      return 0;
    } 
};

export const isDowngradeAllowed = async (emailId) => {
	try {
		const response = await axiosRequestInterceptor.post(`users/isDowngradeAllowed`, {
			emailId: emailId
		});

		let data = response.data;
		return data.isDowngradeAllowed;
	} catch (error) {
		console.log(error);
		return false;
	} 
}